export default __webpack_public_path__ + "static/3-bc4bc38073deea8c193fc5840e91ef70.jpeg";